module.exports = __webpack_public_path__ + "static/img/team-2.81af507.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/team-2.png
// module id = x9Bz
// module chunks = 1